import script from "./StockList.vue?vue&type=script&setup=true&lang=js"
export * from "./StockList.vue?vue&type=script&setup=true&lang=js"

import "./StockList.vue?vue&type=style&index=0&id=84017c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84017c8e"]])

export default __exports__